import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import cn from 'classnames';
import { FormattedMessage } from 'react-intl';

import Icon from '../../../Icon';
import Loader from '../../Loader';
import styles from './styles.styl';

const EmptySearchResults = ({
  loading,
  emptyState,
  defaultState,
  succeed,
  defaultIcon = 'no-posts',
  withTabs,
}) => {
  return (
    <div styleName={cn('root', { 'root--white': withTabs })}>
      <If condition={!loading}>
        <Icon
          name={succeed ? 'no-one-found' : defaultIcon}
          size={148}
          className="pb4"
        />
        <p className="ttu" styleName="text">
          {succeed ? emptyState : defaultState}
        </p>
        <If condition={withTabs && !succeed}>
          <p className="pt4" styleName="text">
            <FormattedMessage id="dialog.common.selectTab" />
          </p>
        </If>
        <Else />
        <Loader />
      </If>
    </div>
  );
};

EmptySearchResults.propTypes = {
  defaultState: PropTypes.string.isRequired,
  emptyState: PropTypes.string.isRequired,
  defaultIcon: PropTypes.string,
  loading: PropTypes.bool,
  withTabs: PropTypes.bool,
  succeed: PropTypes.bool,
};

export default CSSModules(EmptySearchResults, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/common/SearchDialog/EmptySearchResults/index.jsx